// theme.ts
import { createTheme } from "@mui/material/styles";
const theme = createTheme({
    palette: {
        primary: {
            main: "#005533", // Custom green color
        },
    },
    typography: {
        fontSize: 13,
        fontFamily: '"Roboto Condensed", Helvetica, Arial, Lucida, sans-serif',
        body1: {
            fontSize: "1.0rem",
        },
        body2: {
            fontSize: "1.0rem",
        },
    },
    components: {
        //AppBar 
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: "#ffffff",
                    color: "#005533",
                    minHeight: "70px",
                },
            },
        },
        //Toolbar
        MuiToolbar: {
            styleOverrides: {
                root: {},
            },
        },
        //Drawer
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: "linear-gradient(135deg, rgb(0, 154, 77) 0%, rgb(15, 86, 64) 100%)",
                    color: "#ffffff",
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    background: "linear-gradient(160deg, rgb(0, 154, 77) 0%, rgb(15, 86, 64) 100%)",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: "#ffffff", // Font color for table head cells
                    padding: "8px 5px !important",
                    fontWeight: "bold",
                    fontSize: "1.0rem",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: "#005533", // Custom green color
                    '&:hover': {
                        backgroundColor: "#00442e", // Slightly darker green for hover state
                    },
                    color: "#ffffff", // Font color for buttons
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                //color: "#005533", // Custom green color for RadioButtonChecked
                },
            },
        },
    },
});
export default theme;
